import { InventoryRepository } from '@lib/api/repository/inventory/inventory.repository';
import { InventoryInput, OwnerInventoryFilters } from '@lib/types';
import { AdminPageFilters } from '@lib/types/admin-page';

export default class InventoryService {
  constructor(private repository: InventoryRepository) {}

  listAdminPage(filters: AdminPageFilters, signal?: AbortSignal) {
    return this.repository.listAdminPage(filters, signal);
  }

  listByStorePage(
    slug: string,
    filters?: Record<string, string>,
    signal?: AbortSignal,
  ) {
    return this.repository.listByStorePage(slug, filters, signal);
  }

  listByStore(
    slug: string,
    filters?: Record<string, string>,
    signal?: AbortSignal,
  ) {
    return this.repository.listByStore(slug, filters, signal);
  }

  listMine(filters?: OwnerInventoryFilters, signal?: AbortSignal) {
    return this.repository.listMine(filters, signal);
  }

  listAdmin(signal?: AbortSignal) {
    return this.repository.listAdmin(signal);
  }

  create(input: InventoryInput) {
    return this.repository.create(input);
  }

  createBatch(items: InventoryInput[]) {
    return this.repository.createBatch(items);
  }

  update(id: string, input: InventoryInput) {
    return this.repository.update(id, input);
  }

  updateStock(id: string, quantity: number) {
    return this.repository.updateStock(id, quantity);
  }

  remove(id: string) {
    return this.repository.remove(id);
  }

  removeByGame(gameCode: string) {
    return this.repository.removeByGame(gameCode);
  }

  setActive(id: string, active: boolean) {
    return this.repository.setActive(id, active);
  }

  setMineActive(id: string, active: boolean) {
    return this.repository.setMineActive(id, active);
  }
}
